// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  position: relative;
}
:host input.input-search {
  caret-color: black;
}
:host input.input-search.blocked {
  opacity: 0.8;
  pointer-events: none;
}
:host .dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 0;
  max-height: 300px;
  overflow-y: auto;
  min-width: 300px;
  z-index: 99999;
  display: block;
}
:host .dropdown-menu .dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 61px;
}
:host .dropdown-menu .dropdown-item .user-thumbnail {
  width: 50px;
  height: 50px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
:host .dropdown-menu .dropdown-item:hover {
  cursor: pointer;
}
:host .label-container,
:host .field-container {
  padding: 10px;
}
:host .label-container {
  flex: 1;
  max-width: 200px;
  text-align: right;
  font-size: 14px;
  padding-top: 15px;
}
:host .field-container {
  flex: 3;
  max-width: 500px;
  font-size: 14px;
  position: relative;
}
:host .field-container.selected-admin-row {
  display: flex;
  justify-content: flex-start;
  gap: 15px;
  align-items: center;
  margin-top: 20px;
}
:host .field-container.selected-admin-row .thumbnail-img {
  width: 60px;
}
:host .field-container.selected-admin-row .icon-close {
  position: absolute;
  top: 5px;
  right: 0;
  margin: auto;
}
:host .field-container.selected-admin-row .icon-close:hover {
  cursor: pointer;
}
:host .field-container.selected-admin-row .admin-thumbnail {
  width: 50px;
  height: 50px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
:host .field-container.selected-admin-row .admin-name span {
  display: block;
  margin-bottom: 5px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
